import React from "react";
import "antd/dist/antd.css";
import "./index.scss";
import { PAGE_COMPANY } from "../../config";
import Top from "../../components/common/TopBack/index";
import {
  Layout,
  Input,
  Button,
  Row,
  message,
  Typography,
  Table,
  Form,
  DatePicker,
  Tabs,
  Popconfirm,
  Radio,
  Select,
  Space,
} from "antd";
import { moduleList, deleteModule, getQiNiuToken } from "../../utils/api";
import actionWays from "../../redux/actions";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import Construction from "./components/Construction";
import UpdateConstruction from "./components/UpdateConstruction";
import Particulars from "./components/Particulars";
import {
  general_websiteList,
  general_module_code,
  general_module_type,
  general_classification_type,
} from "../../utils/dictionary";
import moment from "moment";
const { TabPane } = Tabs;

const { Content } = Layout;
const { Title } = Typography;
class New extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      newContent: {},
      pageContent: [],
      current: 1,
      status: 0,
      loading: true,
      title: "",
      recordTime: "",
      updateConstructionVisible: false,
      constructionVisible: false,
      particularsVisible: false,
      particularsContent: {},
      updateConstructionContent: {},
      websiteName: general_websiteList[0].websiteName,
      websiteCode: general_websiteList[0].websiteCode,
      websiteIndex: 0,
      moduleCode:
        general_module_code[general_websiteList[0].websiteCode][0].moduleCode,
      moduleType:
        general_module_type[
          general_module_code[general_websiteList[0].websiteCode][0].moduleCode
        ][0],
      classification:
        general_classification_type[
          general_module_code[general_websiteList[0].websiteCode][0].moduleCode
        ][0],
      dataSource: [],
    };
    this.industryNews = null;
  }

  componentDidMount() {
    console.log(this.props.userLoginInfo);
    this.getPages();
  }
  getQiNiu = async () => {
    const result = await getQiNiuToken();
    if (result) {
      localStorage.setItem("qiniuToken", result);
    }
  };

  getPages = async () => {
    this.setState({
      loading: true,
    });
    let opt = {};
    const {
      current,
      websiteName,
      websiteCode,
      moduleCode,
      moduleType,
      classification,
    } = this.state;
    opt.websiteName = websiteName;
    opt.websiteCode = websiteCode;
    opt.moduleCode = moduleCode;
    opt.moduleType = moduleType;
    opt.codeBak = classification;
    opt.pageIndex = current - 1;
    opt.pageSize = 20;
    let data = await moduleList(opt);
    if (data.code == 0) {
      const dataSourceList = [];
      for (let i = 0; i < data.data.pageContent.length; i++) {
        console.log(
          "JSON.parse(data.data[i].moduleValue)",
          JSON.parse(data.data.pageContent[i].moduleValue)
        );
        let obj = JSON.parse(data.data.pageContent[i].moduleValue);
        dataSourceList.push({
          ...data.data.pageContent[i],
          ...obj,
        });
      }
      console.log(" data.data", dataSourceList);

      this.setState({
        newContent: data.data,
        pageContent: data.data,
        dataSource: dataSourceList,
        loading: false,
      });
    } else {
      if (!!data) {
        message.error(data.message);
      } else {
        message.error("接口异常");
        this.setState({
          loading: false,
        });
      }
    }
  };
  componentWillUnmount() {}
  getParticulars = (value) => {
    this.setState(
      {
        particularsContent: value,
      },
      () => {
        this.handleParticularsVisible(true);
      }
    );
  };
  getUpdateConstruction = (value) => {
    this.setState(
      {
        updateConstructionContent: value,
      },
      () => {
        this.handleUpdateConstructionVisible(true);
      }
    );
  };
  delete = async (e) => {
    let opt = {};
    opt.moduleId = e.id;
    let data = await deleteModule(opt);
    if (!!data && data.code === 0) {
      this.getPages();
      message.success("删除成功");
    } else {
      if (!!data) {
        message.error(data.message);
      } else {
        message.error("接口异常");
        this.setState({
          loading: false,
        });
      }
    }
  };

  columns = [
    {
      title: "标题",
      dataIndex: "title",
    },
    {
      title: "类型",
      dataIndex: "moduleType",
    },
    {
      title: "分类",
      dataIndex: "codeBak",
    },
    {
      title: "创建时间",
      dataIndex: "createTime",
      valueType: "date",
    },
    {
      title: "修改时间时间",
      dataIndex: "updateTime",
      search: false,
    },
    {
      title: "操作",
      dataIndex: "option",
      valueType: "option",
      render: (_, record) => [
        <Space>
          <Popconfirm
            onConfirm={() => {
              this.delete(record);
            }}
            title="确认删除？"
          >
            <a style={{ color: "rgb(75, 190, 205)" }} href="#">
              删除
            </a>
          </Popconfirm>
          <a
            style={{ color: "rgb(75, 190, 205)" }}
            onClick={() => {
              this.getUpdateConstruction(record);
            }}
          >
            编辑
          </a>
          <a
            style={{ color: "rgb(75, 190, 205)" }}
            onClick={() => {
              this.getParticulars(record);
            }}
          >
            详情
          </a>
        </Space>,
      ],
    },
  ];
  onChangeNewList(type, value) {
    if (type == "current") {
      this.setState(
        {
          current: value.current,
        },
        () => {
          this.getPages();
        }
      );
    } else if (type == "status") {
      this.setState(
        {
          status: value,
          current: 1,
        },
        () => {
          this.getPages();
        }
      );
    }
  }
  onFinish = async (value) => {
    // value.recordTime != undefined ? value.recordTime = moment(value.recordTime).format('YYYY-MM-DD') : ''
    // value.title != undefined ? value.title = value.title : ''

    this.setState(
      {
        loading: false,
      },
      () => {
        this.getPages();
      }
    );
  };
  handleConstructionVisible = async (value) => {
    this.setState({
      constructionVisible: value,
    });
  };
  handleParticularsVisible = async (value) => {
    this.setState({
      particularsVisible: value,
    });
  };
  handleUpdateConstructionVisible = async (value) => {
    this.setState({
      updateConstructionVisible: value,
    });
  };
  render() {
    const {
      newContent,
      loading,
      current,
      status,
      constructionVisible,
      particularsVisible,
      particularsContent,
      updateConstructionVisible,
      updateConstructionContent,
      pageContent,
      websiteIndex,
      websiteName,
      websiteCode,
      moduleCode,
      moduleType,
      classification,
      dataSource,
    } = this.state;
    return (
      <Layout
        style={{ minHeight: "100%", minWidth: "100%", backgroud: "none" }}
      >
        <Top />
        <Layout>
          <div id="general">
            <div className="col-lg-1"></div>
            <div className="col-lg-10 general_con">
              <Row className="choose_general">
                <div>
                  <label>网站：</label>
                  <Select
                    onChange={(e) => {
                      const code = general_websiteList[e].websiteCode;
                      this.setState(
                        {
                          websiteCode: code,
                          websiteName: general_websiteList[e].websiteName,
                          moduleCode: general_module_code[code][0].moduleCode,
                          moduleType:
                            general_module_type[
                              general_module_code[code][0].moduleCode
                            ][0],
                          classification:
                            general_classification_type[
                              general_module_code[code][0].moduleCode
                            ][0],
                        },
                        () => {
                          this.getPages();
                        }
                      );
                    }}
                    value={websiteIndex}
                    style={{ marginBottom: 8 }}
                  >
                    {general_websiteList.map((item, index) => {
                      return (
                        <Select.Option value={index} key={index}>
                          {item.websiteName}
                        </Select.Option>
                      );
                    })}
                  </Select>
                  <label>模块：</label>
                  <Select
                    onChange={(e) => {
                      this.setState(
                        {
                          moduleCode: e,
                          moduleType: general_module_type[e][0],
                          classification: general_classification_type[e][0],
                        },
                        () => {
                          this.getPages();
                        }
                      );
                    }}
                    value={moduleCode}
                    style={{ marginBottom: 8, width: 150 }}
                  >
                    {general_module_code[websiteCode].map((item, index) => {
                      return (
                        <Select.Option value={item.moduleCode} key={index}>
                          {item.moduleName}
                        </Select.Option>
                      );
                    })}
                  </Select>
                  <label>类型：</label>
                  <Select
                    onChange={(e) => {
                      this.setState(
                        {
                          moduleType: e,
                        },
                        () => {
                          this.getPages();
                        }
                      );
                    }}
                    allowClear={true}
                    value={moduleType}
                    style={{ marginBottom: 8, width: 250 }}
                  >
                    {general_module_type[moduleCode].map((item, index) => {
                      return (
                        <Select.Option value={item} key={index}>
                          {item}
                        </Select.Option>
                      );
                    })}
                  </Select>
                  {general_classification_type[moduleCode].length ? (
                    <>
                      <label>分类：</label>
                      <Select
                        onChange={(e) => {
                          this.setState(
                            {
                              classification: e,
                            },
                            () => {
                              this.getPages();
                            }
                          );
                        }}
                        value={classification}
                        style={{ marginBottom: 8, width: 230 }}
                        allowClear={true}
                      >
                        {general_classification_type[moduleCode].map(
                          (item, index) => {
                            return (
                              <Select.Option value={item} key={index}>
                                {item}
                              </Select.Option>
                            );
                          }
                        )}
                      </Select>
                    </>
                  ) : (
                    <></>
                  )}
                </div>
                <div className="button">
                  <Button
                    type="primary"
                    onClick={() => this.handleConstructionVisible(true)}
                  >
                    新建-{moduleType}
                  </Button>
                </div>
              </Row>
              <div className="new_Content">
                <Table
                  onChange={(value) => this.onChangeNewList("current", value)}
                  columns={this.columns}
                  dataSource={dataSource}
                  loading={loading}
                  pagination={{
                    defaultCurrent: current,
                    total: newContent.current,
                    pageSize: 20,
                  }}
                />
              </div>
            </div>
            <div className="col-lg-1"></div>
          </div>
          {constructionVisible ? (
            <Construction
              getPages={this.getPages}
              userLoginInfo={this.props.userLoginInfo}
              constructionVisible={constructionVisible}
              handleConstructionVisible={this.handleConstructionVisible}
              websiteName={websiteName}
              websiteCode={websiteCode}
              moduleCode={moduleCode}
              moduleType={moduleType}
              classification={classification}
            />
          ) : null}
          <Particulars
            particularsContent={particularsContent}
            userLoginInfo={this.props.userLoginInfo}
            particularsVisible={particularsVisible}
            handleParticularsVisible={this.handleParticularsVisible}
            websiteName={websiteName}
            websiteCode={websiteCode}
            moduleCode={moduleCode}
            moduleType={moduleType}
            classification={classification}
          />
          {updateConstructionVisible ? (
            <UpdateConstruction
              getPages={this.getPages}
              updateConstructionContent={updateConstructionContent}
              userLoginInfo={this.props.userLoginInfo}
              updateConstructionVisible={updateConstructionVisible}
              handleUpdateConstructionVisible={
                this.handleUpdateConstructionVisible
              }
              websiteName={websiteName}
              websiteCode={websiteCode}
              moduleCode={moduleCode}
              moduleType={moduleType}
              classification={classification}
            />
          ) : null}
        </Layout>
      </Layout>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    userLoginInfo: state.userLoginInfo,
  };
};

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    saveLoginInfo: (...args) => dispatch(actionWays.saveLoginInfo(...args)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(New));
